const defaultState = {
  uid: null,
  token: null,
  channelId: null,
  userInfo: null,
  nobleInfo: {
    // 贵族等级数据
    nobleValue: 0,
    nobleLevel: 0,
    expireDay: 0,
  },
  rootConfig: null, //全局配置
  client: 'WEB', //客户端
  pcExp: 0, //窗口展开状态
  prefix: '', //图片存储域名
  point: {}, //经纬度
  register: 1, //1:微信 2:QQ 3:手机
  clientInfo: {}, //客户端数据
  login_visible: false, //是否显示登录窗
  webim_visible: false, //显示聊天窗口
  bindPhoneInfo: { visible: false, close: true }, //显示绑定手机 visible 是否展示弹窗 close 是否显示关闭按钮
  setRemark_visible: false, //显示设置备注
  newRemarkName: false, //设置备注名
  setRemark_data: false, //设置备注内容
  setPwd_visible: false, //显示设置密码
  setPwd_type: 0, //设置密码的场景 0初始化 1修改 2忘记
  dsModal: false, //显示大神主页
  affinityData: null, //用户关系数据
  AffinityInvite: false, //显示关系邀请弹窗
  affinitySpaceModal: false, //显示亲密空间弹窗
  affinityDeleteModal: false, //显示亲密关系解除弹窗
  webim: {}, //NIM数据链接存储
  blackList: [], //nim黑名单
  systemTime: 0, //服务器时间与本地时间差值
  tipOff: null, //举报
  award_visible: false, //奖励弹窗
  awardData: {}, //奖励内容
  coupon_visible: false, //新手礼包弹窗
  coupon_data: [], //新手礼包列表
  stepInfo: {}, //注册步骤信息
  step_visible: false, //新手注册步骤填写弹窗
  isShowPerfect: false, //是否展示完善资料提示
  roomBlankTypes: {}, //开黑房间类型
  blackTeamRoomTypeDict: [], //开黑游戏类型
  confirmRoomPwd: false, //开黑房密码验证
  events: {},
  medalGetVisible: false, //获得勋章弹窗
  medalGetData: null, //勋章弹窗数据
  medalGetDatas: [], //勋章弹窗数据集合
  userChatLimit: 0, //聊天限制对应的等级
  userLevel: {}, //聊天限制对应的列表
  bindCert_visible: false, //显示实名
  clickSongType: [
    //点唱类型
    { key: 0, name: '试音' },
    { key: 1, name: '点歌' },
    { key: 2, name: '包场' },
  ],
  clickMusicConfig: {
    // 点唱卡相关配置
    loading: false, // 是否在加载中
  },
  isVerifiedRealName: true, //true 不展示 |  false 展示
  commentEnum: [
    { id: 1, text: '吐槽' },
    { id: 2, text: '不满意' },
    { id: 3, text: '一般' },
    { id: 4, text: '满意' },
    { id: 5, text: '非常满意' },
  ], //评论枚举
  showFirstReCharge: { visible: false, recharge: false }, //recharge 是否是从充值弹窗中展示的
  chatSensitiveStatus: { privateChat: false, room: false }, //敏感词校验状态
  isOpenIntrusion: null, //是否开启防打扰
  isNewUserInfo: null, //由于第三方登录强制绑定手机号前置，所以需要保存当前新用户的信息 新用户有新手礼包弹窗
  syUserLoginInfo: null, //用户迁移，需要校验用户所填写的手机号，所以需要保留接口返回的用户信息
  syBindPhoneVisible: false, //用户迁移，显示绑定手机
  sySecondaryAuthSuccess: false, //二次授权登录成功
  sySecondaryAuthError: {
    //二次授权错误信息
    wx: false,
    qq: false,
    phone: false,
  },
  ipPlaceView: {}, //是否展示归属地
  langDicts: null, // 语言字典
  sessionBanner: [], // IM 私聊上方 Banner 列表
  serverSwitch: null, // 服务器返回的状态
  modalZIndex: {
    // 由于部分弹窗（如，聊天，下单）层级相同，并且两个弹窗会同时出现，所以定义一个永远高于对方的层级
    chatModal: 1001,
    orderModal: 1001,
  },
  isAgoraRTC: true,
  showAnnualModal: false,
  isStarAmountDot: false, // 星力值是否发生变化
  realAuthData: null, // 实名数据
  riskAuthData: null, // 风控数据
};

export default (state = defaultState, action) => {
  let newState = { ...state };
  switch (action.type) {
    //设置数据字典内容
    case 'set_system_dicts':
      //开黑分类
      newState.blackTeamRoomTypeDict = action.blackTeamRoomTypeDict || [];
      if (action.blackTeamRoomTypeDict) {
        let roomBlankTypes = {};
        action.blackTeamRoomTypeDict.forEach(
          (item) => (roomBlankTypes[item.categoryId] = item.name)
        );
        newState.roomBlankTypes = roomBlankTypes;
      }
      // 直播间类型 todo 2.22.3 直播间分类新增二级分类
      if (action.roomTypeDict) {
        const roomTypeList = [];
        const childrenList = [];
        action.roomTypeDict.forEach((n) => {
          if (n.type === 1 || n.type === 100) {
            roomTypeList.push(n);
          } else if (n.type === 1000) {
            childrenList.push(n);
          }
        });
        childrenList.forEach((n) => {
          const findIndex = roomTypeList.findIndex((_n) => _n.id === n.pid);
          if (findIndex > -1) {
            if (!roomTypeList[findIndex].children)
              roomTypeList[findIndex].children = [];
            roomTypeList[findIndex].children.push(n);
          }
        });
        newState.roomTypeDict = roomTypeList;
      }
      //房间模板
      let roomModeList = [];
      action.roomModeList.forEach((item) => {
        if (item.games && item.games.length > 0) {
          item.games.forEach((citem) => {
            roomModeList.push({
              id: item.id,
              rmodeId: item.rmodeId,
              rmodeRemark: item.rmodeRemark,
              rtypeId: item.rtypeId,
              rtypeRemark: item.rtypeRemark,
              gameId: citem.id,
              appUrl: citem.appUrl,
              pcUrl: citem.pcUrl,
              seq: citem.seq,
              gameName: citem.gameName,
              icon1: citem.icon1,
              icon2: citem.icon2,
            });
          });
        } else {
          roomModeList.push({
            ...item,
            roomId: null,
          });
        }
      });
      newState.roomModeList = roomModeList;
      //nim黑名单
      newState.blackList = action.blackList || [];
      window.blackList = action.blackList || [];
      //主题
      newState.roomMode = {};
      //服务器时间
      newState.systemTime = action.systemTime - +new Date();
      window.ServiceTimeStamp = action.systemTime - +new Date();
      action.roomTypeDict
        .filter((item) => item.type === 100)
        .forEach((item) => {
          newState.roomMode[item.id] = { ...item };
        });
      //弹幕配置
      newState.barrageConfig = action.barrageConfig;
      //vip配置
      newState.vipConfig = action.vipConfig;
      //房间角色配置
      newState.roomRoles = {};
      action.roleList &&
        action.roleList.forEach((item) => {
          newState.roomRoles[item.roleId] = item;
        });
      //举报类型
      newState.reportReason = action.reportReason;
      //聊天限制
      newState.userChatLimit = Number(action.userChatLimit);
      //角色列表
      newState.userLevel = action.userLevel;
      //IP归属地是否展示
      newState.ipPlaceView = action.ipPlaceView;
      // {switchStatus: 1, pcUrl: "xxx"} 0: 正常 1:维护中
      newState.serverSwitch = action.serverSwitch;
      newState.vnum = action?.appLoginStatusConfig?.vnum ?? null;
      // 进场秀进场展示限制
      newState.baseConstants = action.baseConstants;
      // 音乐版权
      newState.musicVendorLogos = action.musicVendorLogos;
      // 字典报错信息
      newState.chatErrCode = action.chatErrCode;
      break;
    //设置客户端参数
    case 'set_client_info':
      newState.clientInfo = action.data;
      newState.client = 'PC';
      break;
    //设置客户端参数
    case 'set_client_electron_info':
      newState.clientInfo = action.data;
      newState.client = action.data.easyPath ? 'UELE' : 'ELE';
      break;
    //首次登录
    case 'change_uid_token':
      newState.register = action.register;
      newState.uid = action.uid;
      newState.token = action.token;
      break;
    //更新用户资料
    case 'change_user_info':
      newState.userInfo = action.data;
      break;
    //注销
    case 'clear_user_info':
      newState.userInfo = null;
      newState.uid = null;
      newState.token = null;
      newState.register = 1;
      break;
    //首次连接同步
    case 'nim_sync_done':
      newState.webim = { ...newState.webim, ...action.data };
      break;
    //更新会话列表
    case 'nim_change_session':
      newState.webim.sessions = action.sessions;
      break;
    //更新订阅
    case 'nim_update_multi_status':
      newState.webim.onlineStatus = action.data;
      break;
    //显示对话窗口
    case 'change_nim_chat':
      if (action.data) {
        newState.webim.to = { ...action.data.to };
        newState.webim.sessions = [...action.data.sessions];
        newState.webim.users = { ...action.data.users };
        newState.webim.jnid = action.data.jnid || null;
        newState.modalZIndex = {
          // 层级永远高于下单弹窗
          ...state.modalZIndex,
          chatModal: state.modalZIndex.orderModal + 1,
        };
        newState.webim_visible = true;
      } else {
        newState.webim.to = null;
        newState.webim_visible = false;
      }
      break;
    //更新弹幕配置序号
    case 'update_barrage_index':
      newState.barrageIndex = action.index || 0;
      break;
    //更新发送类型
    case 'update_send_type':
      newState.sendType = action.send || 0;
      break;
    //显示绑定手机窗口
    case 'change_phone_modal':
      newState.bindPhoneInfo = {
        visible: action.data.visible,
        close: action.data.close,
      };
      break;
    //用户迁移 - 显示绑定手机窗口
    case 'change_sy_phone_modal':
      newState.syBindPhoneVisible = action.data;
      break;
    //显示设置备注弹窗
    case 'change_remark_modal':
      newState.setRemark_visible = action.data.show;
      newState.setRemark_data = { ...action.data };
      break;
    //刷新会话列表
    case 'refresh_nim_session':
      newState.newRemarkName = action.data.remarkName;
      break;
    //显示修改密码弹窗
    case 'change_pwd_modal':
      newState.setPwd_visible = action.data.show;
      newState.setPwd_type = action.data.type;
      break;
    //显示举报窗口
    case 'change_tip_off':
      newState.tipOff = action.data ? { ...action.data } : null;
      break;
    //奖励弹窗
    case 'show_award_modal':
      newState.award_visible = true;
      newState.awardData = { ...action.data };
      break;
    case 'register_call':
      newState.events[action.data.name] = action.data.call;
      break;
    case 'emit_call':
      let call = newState.events[action.data.name];
      if (call && typeof call == 'function') {
        call(action.data.payload || {});
      }
      break;
    case 'show_medal':
      newState.medalGetVisible = true;
      let beforeLength = newState.medalGetDatas.length;
      let nowTime = new Date().getTime();
      newState.medalGetDatas.push(action.data);
      if (beforeLength == 0) {
        newState.medalGetData = { ...action.data, expire: nowTime + 3000 };
      } else {
        newState.medalGetDatas.forEach((item, index) => {
          let expire = nowTime + (index + 1) * 3000;
          item.expire = expire;
        });
      }
      break;
    case 'hide_medal':
      newState.medalGetDatas.shift();
      newState.medalGetVisible = false;
      if (newState.medalGetDatas.length > 0) {
        newState.medalGetVisible = true;
        newState.medalGetData = newState.medalGetDatas[0];
      } else {
        newState.medalGetDatas = [];
        newState.medalGetVisible = false;
      }
      break;
    case 'set_sy_user_login_info':
      newState.syUserLoginInfo = action.data;
      break;
    case 'set_sy_secondary_auth_error':
      newState.sySecondaryAuthError = {
        wx: action.data.wx,
        qq: action.data.qq,
        phone: action.data.phone,
      };
      break;
    case 'set_sy_secondary_auth_success':
      newState.sySecondaryAuthSuccess = action.data;
      break;
    default:
      newState = { ...state, ...action.data };
      break;
  }
  return newState;
};
